export const referenceStyles = {
  ml: '20%',
  height: '100%',
  '.shadow': {
    display: 'none',
  },
};
